import styled from 'styled-components';
import { Risk } from '@/components/views/Resolution886/enums';

interface RiskBadgeProps {
	backgroundColor: string;
	width?: string;
}

export const RiskBadge = styled.div<RiskBadgeProps>`
	align-items: center;
	background-color: ${({ backgroundColor }) => backgroundColor};
	border-radius: ${({ theme }) => theme.border.border_radius.br_sm};
	color: ${({ theme }) => theme.palette.secondary.white};
	display: flex;
	font-size: ${({ theme }) => theme.sizes.fonts.fs_sm};
	font-weight: ${({ theme }) => theme.sizes.weights.semibold};
	height: 40px;
	justify-content: center;
	padding: 0 16px;
	width: ${({ width }) => width || 'fit-content'};
`;

export const StatusContent = styled.div<{ risk?: Risk; size?: 'small' | 'large' }>`
	background-color: ${({ theme, risk }) =>
		risk === Risk.TOLERABLE
			? theme.colors.risk.low
			: risk === Risk.MODERATE
			? theme.colors.risk.medium
			: risk === Risk.NOT_TOLERABLE
			? theme.colors.risk.high
			: theme.palette.secondary[100]};

	border-radius: 4px;
	min-height: ${({ size }) => (size === 'small' ? '32px' : '40px')};
	padding: ${({ size }) => (size === 'small' ? '4px 8px' : '8px')};
	width: ${({ size }) => (size === 'small' ? 'fit-content' : '100%')};
	text-align: center;

	p {
		color: ${({ theme, risk }) => (risk ? theme.palette.secondary.white : theme.colors.text)} !important;
		font-size: 14px !important;
		line-height: ${({ theme }) => theme.sizes.line_heights.lh_md} !important;
		letter-spacing: ${({ theme }) => theme.sizes.letter_spacings.ls_lg} !important;
		font-weight: ${({ theme, risk }) =>
			risk ? theme.sizes.weights.semibold : theme.sizes.weights.regular} !important;
		margin: 0 !important;
		text-align: center;
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
	}
`;
